import React from "react";

// Material
import { makeStyles } from "@material-ui/core";
import Box from "@material-ui/core/Box";

// Config
import useTranslate from "src/hooks/useTranslate";
import colors from "src/config/colors";
import styles from "src/config/styles";

const useStyles = makeStyles(theme => ({
  root: {
    border: styles.values.border,
    borderColor: colors.lockedCardText,
    color: colors.lockedCardText,
    padding: "4px 8px",
    backgroundColor: "white",
    fontSize: "8px",
    borderRadius: theme.shape.borderRadius,
    overflow: "hidden",
    borderWidth: ".5px",
    display: "flex",
    alignItems: "center",
    gap: "4px"
  },
  info: { width: "8px", height: "8px" },
  text: {
    textTransform: "uppercase"
  }
}));

const RequiredChip = () => {
  const classes = useStyles();
  const getText = useTranslate();

  return (
    <Box className={classes.root}>
      <span className={classes.text}>{getText("common.prompts.required")}</span>
    </Box>
  );
};

export default RequiredChip;
